import './rating.css';
import StarImg from '../../../assets/star.png';

export const Star = () => {
  return <img src={StarImg} alt="Star" style={{ width: 16, height: 16 }}></img>;
};
export const Rating = ({ rating }) => {
  const getStars = () => {
    if (rating === '0' || 'NOT RATED' === String(rating).toUpperCase() || rating === null) {
      return <div className="not-rated-label text-normal text-gray-2">Not rated</div>;
    }
    const result = [];
    for (let i = 0; i < rating; i++) {
      result.push(<Star key={i}></Star>);
    }
    return result;
  };
  return <div className="rating-container">{getStars()}</div>;
};
